import state from "./moduleUserSignatureState";
import mutations from "./moduleUserSignatureMutations";
import actions from "./moduleUserSignatureActions";
import getters from "./moduleUserSignatureGetters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}